
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-roleplay/[[...slug]]",
      function () {
        return require("private-next-pages/ai-roleplay/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-roleplay/[[...slug]]"])
      });
    }
  